<template>
    <div class="blueBg content">
        <div class="innerSlide">
            <template v-for="category in datas">
                <template v-if="category.id == 1">
                    <template v-if="!isChild">
                        <p class="time">{{ $t('studies.page.study_time') }} {{ time }}</p>
                    </template>
                    <h3>
                        {{ $t('studies.page.recommended') }}
                        <a :href="'/studies-category?id=1'" class="viewmore pc">
                            {{ $t("studies.page.more") }}
                        </a>
                    </h3>
                    <div class="contentSliderWrapper">
                        <div class="contentSlider big">
                            <div class="contentItem" v-for="data in category.datas">
                                <div class="contentWrapper">
                                    <router-link ref="link" :to="{path: 'studies-detail', query: {id: data.id, img: data.img, url: data.url}}" v-bind:style="{'background': 'url(' + backgroundImages[data.id] + ') center no-repeat'}">
                                        <div class="title">{{ $t('studies.title.' + data.id) }}</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <a :href="'/studies-category?id=1'" class="viewmore sp">
                        {{ $t("studies.page.more") }}
                    </a>
                </template>
            </template>


            <template v-for="category in datas">
                <template v-if="category.id > 1">
                    <h3>
                        {{ $t('studies.page.' + category.name) }}
                        <a :href="'/studies-category?id=' + category.id" class="viewmore pc">
                            {{ $t("studies.page.more") }}
                        </a>
                    </h3>

                    <div class="contentSliderWrapper">
                        <div class="contentSlider small">
                            <div class="contentItem" v-for="data in category.datas">
                                <div class="contentWrapper">
                                    <router-link ref="link" :to="{path: 'studies-detail', query: {id: data.id, img: data.img, url: data.url}}" v-bind:style="{'background': 'url(' + backgroundImages[data.id] + ') center no-repeat'}">
                                        <div class="title">{{ $t('studies.title.' + data.id) }}</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <a :href="'/studies-category?id=' + category.id" class="viewmore sp">
                        {{ $t("studies.page.more") }}
                    </a>
                </template>
            </template>
        </div>
    </div>
</template>


<script>
    import AuthUtil from '../../utils/AuthUtil';
    import languageService from '../../services/LanguageService';
    import StudiesService from '../../services/StudiesService';

    // 会員種別追加対応
    import UserService from "../../services/UserService";

    export default {
        name: 'studies-top',

        components: {
        },

        data() {
            return {
                time: '00:00:00',
                datas:[],
                isOpenImg01Modal: false,
                isOpenImg02Modal: false,
                lang: 'en',
                contentImagePath: '/cai/common/images/info-screen/',
                backgroundImages: {},
                isChild: false,
            }
        },

        async created() {
            if (AuthUtil.isAuth()) {
                this.fetchUserFrontendData();

                if (!this.isChild) {
                    var datas = await StudiesService.getTime()
                    this.time = datas.data.time
                }
                
            }
            this.lang = languageService.getCurrentLanguageShortCode();
        },

        methods: {
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.isChild = data.is_child;
            },

            handleOnClickOpenImg1Modal() {

            },
            handleOnClickCloseImg1Modal() {

            },
            handleOnClickOpenImg2Modal() {

            },
            handleOnClickCloseImg2Modal() {

            },
            setBackgroundImages(rows) {
                const basePath = this.contentImagePath + this.lang + '/'
                let that = this
                Object.keys(rows).forEach(function(key) {
                    Object.keys(rows[key]['datas']).forEach(function(id) {
                        let row = rows[key]['datas'][id]
                        that.backgroundImages[row['id']] = basePath + row['img']
                    });
                });
            },
        },

        async mounted() {
            var datas = await StudiesService.getCategory()
            this.setBackgroundImages(datas.data)
            this.datas = datas.data

            this.$nextTick(function () {
                // javascript追加
                var scripts = ['/assets/js/jquery-3.4.1.min.js', '/assets/js/modernizr.min.js', '/assets/js/slick.min.js', '/assets/js/wow.min.js', '/assets/js/common.js'];
                var len = scripts.length;
                var i = 0;

                (function appendScript() {
                    if (scripts[i] != undefined){
                        var script = document.createElement('script');
                        script.src = scripts[i];
                        document.body.appendChild(script);

                        if (i++ < len) {
                            script.onload = appendScript;
                        }
                    }
                })();
            })
        },

        watch: {
            '$i18n.locale': function(locale) {
                this.lang = languageService.getCurrentLanguageShortCode();
                this.setBackgroundImages(this.datas)
            }
        }
    }
</script>

<style lang="sass" scoped>
    @import "./assets/css/slick.scss"
    @import "./assets/css/style.scss"
    @import "./assets/css/style2.css"
</style>
